import React from 'react';
import ReactDOM from 'react-dom';

import Warn from './Warn';
import FocusActions from '../actions/FocusActions';
import AjaxRemoteUtil from './AjaxRemoteUtil';

require('../styles/UserFormSetForm.css');
export default class FindForm extends React.Component
{

	static queryHistoryCache = {};

	static show(queryHandler,label,historyCacheKey,parms={},flag='')
	{
		ReactDOM.render(<FindForm parms={parms} queryHandler={queryHandler} cacheKey={historyCacheKey} label={label} flag={flag}/>,document.getElementById("findModal"));
		
	}

	closeHandler(focus = false)
	{
		
		let $reactComponentContainer = $("#findModal");
		ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
		$(this.modalDiv).remove();
		FocusActions.clearSigned();
		if(typeof(window.switchToCurrent) == "function")
			window.switchToCurrent();
	}

	async queryPre()
	{
		let filterTxt = $(this.inputFilter).val();
		if(!this.stepColumn)
		{
			let nowQueryIndex = await this.props.queryHandler(filterTxt,this.nowQueryIndex,this.stepColumn,true);
			FindForm.queryHistoryCache[this.props.cacheKey] = filterTxt;
			if(nowQueryIndex == 0)
			{
				Warn.show({text:"已查找到第一个"});
				//if(this.nowQueryIndex>0)this.nowQueryIndex+=50;
				//else this.nowQueryIndex = 51;
			}
			else
			{
				this.nowQueryIndex = nowQueryIndex;
			}
		}
		else
		{
			let nowQueryIndexObj = await this.props.queryHandler(filterTxt,this.nowQueryIndexObj,this.stepColumn,true);
			FindForm.queryHistoryCache[this.props.cacheKey] = filterTxt;
			if(nowQueryIndexObj == 0)
			{
				Warn.show({text:"已查找到第一个"});
				//if(this.nowQueryIndexObj.row>0)this.nowQueryIndexObj.row+=50;
				//else this.nowQueryIndexObj.row = 51;
			}
			else
			{
				this.nowQueryIndexObj = nowQueryIndexObj;
			}
		}
	
	}

	async query()
	{
		if(AjaxRemoteUtil.tokenNum > 0)
			return;
		let filterTxt = $(this.inputFilter).val();
		
		/*if(this.props.parms && this.props.parms.type == "EnumEditor")
		{
			var _properties = GOTPropertiesUtil.getItemPropertyFinalValue(window.menuItemId,this.props.parms.entityId,this.props.parms.innerId);
			var _dataProvider = _properties.DataProvider;
			if(_dataProvider)
			{
				
				for(let i = 0;i<_dataProvider.length;i++)
				{
					let item = _dataProvider[i];
					if(item.label && item.label.indexOf(filterTxt) != -1)
					{
						filterTxt
					}
				}
			}
				
		}*/
		if(!this.stepColumn)
		{
			let nowQueryIndex = await this.props.queryHandler(filterTxt,this.nowQueryIndex,this.stepColumn);
			FindForm.queryHistoryCache[this.props.cacheKey] = filterTxt;
			if(nowQueryIndex == -1)
			{
				Warn.show({text:"本页找不到正在搜索的数据,已自动加载下一页数据"});
				if(this.nowQueryIndex>0)
				{
					this.nowQueryIndex+=(50-this.nowQueryIndex%50);
				}
				else 
				{
					this.nowQueryIndex = 51;
				}
			}
			else
			{
				this.nowQueryIndex = nowQueryIndex;
			}
		}
		else
		{
			let nowQueryIndexObj = await this.props.queryHandler(filterTxt,this.nowQueryIndexObj,this.stepColumn);
			FindForm.queryHistoryCache[this.props.cacheKey] = filterTxt;
			if(nowQueryIndexObj == -1)
			{
				Warn.show({text:"本页找不到正在搜索的数据,已自动加载下一页数据"});
				if(this.nowQueryIndexObj.row>0)this.nowQueryIndexObj.row+=(50-(this.nowQueryIndex.row)%50);
				else this.nowQueryIndexObj.row = 51;
			}
			else
			{
				this.nowQueryIndexObj = nowQueryIndexObj;
			}
		}
		
	}

	keyDownHandler = (e) =>
	{
		//alert("FindForm document keydown");
		if(e.keyCode == 13)
		{
			this.query();
			e.preventDefault();
			e.stopImmediatePropagation();
		}
		else if(e.keyCode == 27)
		{
			this.closeHandler(true);
			e.preventDefault();
			e.stopImmediatePropagation();
		}
	}

	selectedChanged(select)
	{
		this.stepColumn = select;
		if(select == true)
		{
			$(this.labelNode).hide();
			
		}
		else
		{
			$(this.labelNode).show();
		}
	}

	componentDidMount()
	{
		$(this.checkBox).on('ifChecked',this.selectedChanged.bind(this,true));
		$(this.checkBox).on('ifUnchecked',this.selectedChanged.bind(this,false)); 
		let _checkboxClass = 'icheckbox_minimal-blue14';
		//if(!this.state.allowEdit)
			//_checkboxClass += ' disabled';
		$(this.checkBox).iCheck({
	      checkboxClass: _checkboxClass
		});
		if(FindForm.queryHistoryCache.hasOwnProperty(this.props.cacheKey))
		{
			$(this.inputFilter).val(FindForm.queryHistoryCache[this.props.cacheKey]);
		}
		$(this.inputFilter).focus();
		$(this.inputFilter).select();
		$(document).on("keydown",this.keyDownHandler);
		$(this.modalDiv).draggable({
			handle: ".modal-header" // 只能点击头部拖动
		}); //为模态对话框添加拖拽
	}

	componentWillUnmount()
	{
		//TODO如果没有unmountComponentAtNode手动调用，通过remove并没有调用卸载询问函数 对于该类场景 应如何设计？
		$(document).off("keydown",null,this.keyDownHandler);
	}

	findKeyDownHandler(e)
	{
		
	}

	render()

	{
		let klSty = {display:'none',justifyContent:'flex-end',paddingRight:'15px',paddingTop:'10px'};
		let kValue=false;
		let label='逐个查找';
		if(this.props.flag){
			kValue=true
			label='跨列查找';
			this.stepColumn=true;
		}
		return 	(<div className="modal" style={{display:"flex",justifyContent:"center"}} ref={node => this.modalDiv = node} onKeyDown={this.findKeyDownHandler.bind(this)}>
					<div style={{alignSelf:"center",borderRadius:"2px",width:'508px',height:'153px',display:'flex',flexDirection:'column',background:'#FFFFFF',border:'0 solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:'2px'}}>
		              <div className="modal-header" style={{display:"flex",flexDirection:"row",position:"relative",width:"auto",alignItems:"center",paddingLeft:"2px",position:"relative"}}>
					  	<h5 className="modal-title" style={{paddingLeft:'23px',fontFamily:'STSongti-SC-Bold',fontSize:'16px',color:'#000000'}}>{label}</h5>
						<div className="modal-close" onClick={this.closeHandler.bind(this)}></div>
		              </div>
					  <div style={klSty}>
					  		
					  		<label style={{marginBottom: '0px',marginTop: '1px'}}>跨列搜索</label>
							<div style={{marginLeft:'5px'}}>
								<input ref={node=>this.checkBox = node} type="checkbox" className="minimal" value={kValue}/>
							</div>
					  </div>
		              <div style={{marginTop:'15px',display:'flex',justifyContent:'center',alignItems:'center',position:'relative',paddingLeft:'15px',paddingTop:'5px',paddingBottom:'5px',paddingRight:'5px'}}>
					  	{/* <h5 ref={node=>this.labelNode=node} style={{fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',paddingRight:'10px', marginTop: '7px',marginBottom: '7px'}}>{this.props.label}</h5> */}
					  	<input autoComplete="on" spellCheck="false" type="text" style={{width:"200px",marginRight:"10px",width:'308px',height:'28px',background:'#FFFFFF',border:'1px solid #C4C6CF',borderRadius:'1px',flexGrow:1}} ref={node => this.inputFilter = node}/>
					  </div>
					  <div style={{display:'flex',justifyContent:"flex-end"}}>
					  	<button type="button" className="btn btn-info ufs-require" style={{height:'28px',marginRight:'0px',width:'97px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',color:'#fff'}} onClick={this.queryPre.bind(this)}>查找上一个</button>
						<button type="button" className="btn btn-info ufs-require" style={{height:'28px',marginRight:'0px',width:'97px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',color:'#fff',marginLeft:'10px',marginRight:'15px'}} onClick={this.query.bind(this)}>查找下一个</button>
					  </div>
					</div>
		         </div>
				);
				
		/*return 	(

				<div className="modal" style={{display:"flex",justifyContent:"center"}} ref={node => this.modalDiv = node} onKeyDown={this.findKeyDownHandler.bind(this)}>
					<div style={{alignSelf:"center",borderRadius:"2px",width:'508px',height:'137px',display:'flex',flexDirection:'column',background:'#FFFFFF',border:'0 solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:'2px'}}>
					<div className="modal-header" style={{display:"flex",flexDirection:"row",position:"relative",width:"auto",alignItems:"center",paddingLeft:"2px",position:"relative"}}>
						<h5 className="modal-title" style={{paddingLeft:'23px',fontFamily:'STSongti-SC-Bold',fontSize:'16px',color:'#000000'}}>搜索</h5>
						<div className="modal-close" onClick={this.closeHandler.bind(this)}></div>
					</div>
					<div style={{position:"relative"}}>
							
							<label style={{position:'absolute',top:'4px',right:'45px'}}>跨列搜索</label>
							<div style={{position:'absolute',top:'5px',right:'27px'}}>
								<input ref={node=>this.checkBox = node} type="checkbox" className="minimal"/>
							</div>
					</div>
					<div style={{display:'flex',justifyContent:'center',alignItems:'center',flexGrow:'1',position:'relative',padding:'15px'}}>
						<h5 ref={node=>this.labelNode=node} style={{fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',paddingRight:'10px'}}>{this.props.label}</h5>
						<input autoComplete="on" spellCheck="false" type="text" style={{width:"200px",marginRight:"10px",width:'308px',height:'28px',background:'#FFFFFF',border:'1px solid #C4C6CF',borderRadius:'1px',flexGrow:1}} ref={node => this.inputFilter = node}/>
						
						<button type="button" className="btn btn-info ufs-require" style={{height:'28px',marginRight:'0px',width:'97px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',color:'#fff'}} onClick={this.query.bind(this)}>查找下一个</button>
					</div>
					</div>
				</div>
			);*/
	}
}


// WEBPACK FOOTER //
// ./src/utils/FindForm2.js